/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-unused-vars
import { assign } from "xstate";
import { isNumber } from "lodash";
import {
  ANIMATION_EVENTS,
  ASSET_EVENTS,
  ASSET_TYPES,
  PAGES,
  XR_MODES,
  AR_PLATFORM,
  ACTION_TYPES,
} from "../constants";
import { sendAutoEvent } from "../utils/AnalyticsUtil";
import { generateUIConfig } from "../modules/MachineHelper";
import { getPepperfryTemplate } from "../engineTemplates/pepperfryTemplate";
import {
  checkAssetsLoaded,
  createScene,
  filterAssetObjects,
  getOnLoadtexturesIfAny,
  getCorrelationData,
  getXrModefromURL,
} from "../modules/MachineUtils";

import WaitSM from "./WaitSM";

export const XR_SM_CONST = {
  // States
  LOADING: "LOADING",
  CENTER_AND_SCALE: "CENTER_AND_SCALE",
  ON_LOAD_ANIMATION: "ON_LOAD_ANIMATION",
  READY: "READY",
  CONFIG_LOADED: "CONFIG_LOADED",
  GLB_DOWNLOADED: "GLB_DOWNLOADED",
  ALL_LOADED: "ALL_LOADED",
  CONFIG_NOT_LOADED: "CONFIG_NOT_LOADED",
  ON_LOAD_ASSET_DOWNLOAD: "ON_LOAD_ASSET_DOWNLOAD",
  // Misc
  FINAL_TYPE: "final",
  ID: "XR_SM",
};

const checkHDRILoaded = (actions, skuId) => {
  return {
    conds: [
      () => {
        if (!actions.ConfigLoader.getSKUConfig(skuId)) {
          // actions.RendererState().setPage(PAGES.NO_DATA);
          return false;
        }
        return actions.AssetLoader.isAssetObjectsLoaded(
          filterAssetObjects(actions.ConfigLoader.getSKUConfig(skuId).assets, [
            ASSET_TYPES.HDRI,
            ASSET_TYPES.CUBE_MAP,
          ])
        );
      },
    ],
    events: [ASSET_EVENTS.CONFIG_LOADED, ASSET_EVENTS.ASSET_LOADED],
  };
};

export const XR_SM = (actions, skuId) => ({
  id: XR_SM_CONST.ID,
  initial: XR_SM_CONST.LOADING,
  context: {
    modelId: null,
  },
  states: {
    [XR_SM_CONST.LOADING]: {
      entry: [
        () => actions.RendererState().setPage(PAGES.LOADING),
        assign({ modelId: "abc" }),
      ],
      ...WaitSM(checkHDRILoaded(actions, skuId)),
      onDone: [
        {
          target: XR_SM_CONST.READY,
          cond: () => actions.MainStateStore.getGlobalXRLoad() === 1,
        },
        {
          target: XR_SM_CONST.CONFIG_LOADED,
          cond: () => actions.MainStateStore.getGlobalXRLoad() === 0,
        },
      ],
      // onDone:{target: XR_SM_CONST.CONFIG_LOADED}
    },
    // [XR_SM_CONST.CONFIG_NOT_LOADED]: {
    //   entry: [() => actions.RendererState().setPage(PAGES.NO_DATA)],
    // },
    [XR_SM_CONST.CONFIG_LOADED]: {
      entry: [
        () =>
          sendAutoEvent(
            actions,
            getXrModefromURL(actions.window),
            "Config Loaded",
            true
          ),
        () => createScene(actions, skuId, actions.ConfigLoader),
        () => actions.ARControllerUIState().setEnableARSwitch(true),
      ],
      ...WaitSM(
        checkAssetsLoaded(actions, skuId, [
          ASSET_TYPES.GLTF,
          ASSET_TYPES.TEXTURE,
        ])
      ),
      onDone: { target: XR_SM_CONST.CENTER_AND_SCALE },
    },
    [XR_SM_CONST.CENTER_AND_SCALE]: {
      entry: [
        () => actions.ThreejsScene.enableRenderLoop(),
        (context) => {
          if (
            actions.ThreejsScene.getSceneAddedToDom() &&
            actions.ThreejsScene.getSceneDetails().scene.getObjectByName(
              context.modelId
            ) != null
          ) {
            actions.ThreejsScene.hideScene(false);
            return;
          }
          const skuConfig = actions.ConfigLoader.getSKUConfig(context.skuId);
          const templateConfig = getPepperfryTemplate(context, actions);
          const envConfig = templateConfig.getConfigByPlatform(
            skuConfig.environmentLight
          );
          const modelHashId = skuConfig.models.path;
          const assetObject = actions.AssetLoader.getAsset(modelHashId);
          const clonedObject = actions.ARModels.cloneandAddModel(
            assetObject,
            context.modelId
          );
          actions.ARModels.updateModelOnLoad(context.modelId);
          clonedObject.name = context.modelId;
          actions.ThreejsScene.addModelToScene(
            context.modelId,
            clonedObject,
            skuConfig.models.config.scale
          );
          if (isNumber(envConfig?.exposure)) {
            actions.ARModels.updateEnvMapIntensity(
              context.modelId,
              envConfig?.exposure
            );
          }
          // actions.Tracker.sendToGa(
          //   "",
          //   "",
          //   "Model Added",
          //   "Model Added To Scene In Xr",
          //   true
          // );
          sendAutoEvent(
            actions,
            getXrModefromURL(actions.window),
            "Model Added",
            true
          );
          // actions.Tracker.sendToGa(
          //   "LoadXR",
          //   "",
          //   Math.floor(actions.AssetLoader.getModelSize()).toString(),
          //   `Model added to scene in XR - ${actions.AssetLoader.getModelSize()} MB`,
          //   true
          // );
          // actions.ARModels.updateEnvMap(
          //   context.modelId,
          //   actions.AssetLoader.getAsset(
          //     actions.ConfigLoader.getSKUConfig(skuId).environmentLight[
          //       XR_MODES.XR
          //     ][AR_PLATFORM.THREEJS].lightURL
          //   )
          // );
          actions.ThreejsScene.centerAndScale(
            clonedObject,
            actions.ConfigLoader.getSKUConfig(skuId).models.boxSize
          );
        },
        () =>
          actions.ThreejsScene.setCameraController(
            actions.ConfigLoader.getSKUConfig(skuId).orbitControls
          ),
        () => actions.RendererState().setPage(PAGES.XR),
      ],
      on: {
        [ANIMATION_EVENTS.CENTER_SCALE_COMPLETE]: [
          {
            target: XR_SM_CONST.ON_LOAD_ASSET_DOWNLOAD,
            cond: () => actions.MainStateStore.getGlobalOnLoad() === 0,
          },
          {
            target: XR_SM_CONST.READY,
            cond: () => actions.MainStateStore.getGlobalOnLoad() === 1,
          },
        ],
      },
    },
    [XR_SM_CONST.ON_LOAD_ASSET_DOWNLOAD]: {
      entry: [
        () => {
          console.log("waiting for onload textures to be downloaded");
        },
      ],
      ...WaitSM(getOnLoadtexturesIfAny(actions, skuId)),
      onDone: XR_SM_CONST.ON_LOAD_ANIMATION,
    },
    [XR_SM_CONST.ON_LOAD_ANIMATION]: {
      entry: [
        // eslint-disable-next-line no-unused-vars
        (context) => {
          // eslint-disable-next-line no-unused-vars
          const buttonsConfig = generateUIConfig(
            context.modelId,
            actions,
            actions.ConfigLoader.getSKUConfig(skuId),
            XR_MODES.XR,
            AR_PLATFORM.THREEJS,
            "RENDERER"
          );
          if (buttonsConfig.onLoad) buttonsConfig.onLoad();
          console.log("generating onLoadConfig", buttonsConfig.onLoad, context);
          actions.MainStateStore.setGlobalXRLoad(1);
          // actions.Tracker.sendToGa(
          //   "",
          //   "",
          //   "Initial Interaction Event - XR",
          //   "",
          //   false
          // );
          // actions.Tracker.registerTimeout();
        },
      ],
      on: {
        [ANIMATION_EVENTS.ANIMATION_QUEUE_COMPLETE]: XR_SM_CONST.READY,
      },
    },
    [XR_SM_CONST.READY]: {
      entry: [
        () => actions.RendererState().setPage(PAGES.XR),
        () => actions.ARControllerUIState().setEnableARSwitch(true),
        () => actions.InfoPromptState().setShowInfo(true),
        () => {
          actions.ThreejsScene.addOpacity();
        },
        () => {
          if (actions.MainStateStore.getGlobalXRLoad() === 0) {
            actions.MainStateStore.setGlobalXRLoad(1);
            actions.ThreejsScene.setCameraController(
              actions.ConfigLoader.getSKUConfig(skuId).orbitControls
            );
          }
        },
        () => actions.MainStateStore.setGlobalOnLoad(1),
        (context) => {
          // eslint-disable-next-line no-unused-vars
          const skuConfig = actions.ConfigLoader.getSKUConfig(skuId);
          const buttonsConfig = generateUIConfig(
            context.modelId,
            actions,
            skuConfig,
            XR_MODES.XR,
            AR_PLATFORM.THREEJS,
            "RENDERER"
          );
          console.log("generating uiCOnfig", buttonsConfig, context);
          // actions.Tracker.sendToGa(
          //   "",
          //   "",
          //   "Button Added",
          //   "Button Added To Experience In Xr",
          //   true
          // );
          sendAutoEvent(
            actions,
            getXrModefromURL(actions.window),
            "Button Added",
            true
          );
          actions.useSubmenuStore.getState().setButtonsConfig(buttonsConfig);
          actions.useSubmenuStore
            .getState()
            .setCorrelationFlag(skuConfig?.iconCorrelationV2 ?? false);
          actions.useSubmenuStore
            .getState()
            .setCorrelationConfig(getCorrelationData(buttonsConfig));
          actions.useButtonConfigStore
            .getState()
            .setUIConfig({ submenu: true });
        },
      ],
    },
  },
});
